import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Box, Paper, TableContainer, Typography } from "@mui/material";
import { apiService } from "../../../../api/apiService";
import SipocModal from "../../Admin/Users/SipocModal";
import Styles from "./FinalStatus.module.css";
import StatusTabs from "../../FinalStatusRefactor/StatusTabs";
import SipocCard from "../../FinalStatusRefactor/SipocCard";
import DeleteConfirmationDialog from "../../FinalStatusRefactor/DeleteConfirmationDialog";
import SipocModalAdmin from "../../Admin/Users/Admin-End/SipocModalAdmin";

interface Content {
  suppliers: string;
  outputs: string;
  inputs: string;
  id: number;
  created_at: string;
  updated_at: string;
  status: string;
  bd_stage: string;
  clients: string;
}

interface FinalStatusProps {
  functionL1: string;
  functionL2: string;
  management: string;
}

const statusColors: Record<string, string> = {
  Pending: "#FF5C00",
  Draft: "#D7A833",
  Reverted: "#FF0000",
  Approved: "#058B2B",
};

const FinalStatus: React.FC<FinalStatusProps> = ({
  functionL1,
  functionL2,
  management,
}) => {
  const navigate = useNavigate();
  const handleEdit = (id: number) => {
    navigate(`/operations/management/edit/${id}`, {
      state: { functionL1, functionL2, management }
    });
  };
  const [deletingId, setDeletingId] = useState<number | null>(null);

  const handleClickOpen = (id: number) => {
    setDeletingId(id);
    setOpen(true);
  };


  const { instance } = useMsal(); // Get the MSAL instance for authentication
  const [tabValue, setTabValue] = useState(0);
  const [content, setContent] = useState<Content[]>([]);
  const [filteredContent, setFilteredContent] = useState<Content[]>([]);
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
  const [selectedSipocId, setSelectedSipocId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);



  // const handleClickOpen = () => setOpen(true);
  // console.log("handleClickOpen", handleClickOpen);
  const handleClose = () => setOpen(false);
  const handleOpenModal = (id: string) => {
    setSelectedSipocId(id);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await apiService(
        "/management/business_description_by_functions",
        "GET",
        { function_l1: functionL1, function_l2: functionL2, management: management },
        undefined,
        instance as PublicClientApplication


      );
      const data = response?.data;
      if (Array.isArray(data)) {
        setContent(data);
        setFilteredContent(data);
        setLastUpdate(new Date());
      } else {
        console.error("Invalid data structure:", data);
        setContent([]);
        setFilteredContent([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setContent([]);
      setFilteredContent([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [functionL1, functionL2, management]);

  const handleDelete = async () => {
    if (deletingId === null) return;
  
    setIsLoading(true);
    try {
      // First make the API call
      await apiService(
        `/management/business_description/${deletingId}`,
        "DELETE",
        undefined,
        undefined,
        instance as PublicClientApplication
      );
  
      // Only update state after successful deletion
      await fetchData(); // Refresh data from server
  
    } catch (error) {
      console.error("Error deleting item:", error);
      // Optionally show error message to user
    } finally {
      setIsLoading(false);
      setDeletingId(null);
      handleClose();
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    const statuses = ["All", "Pending", "Approved", "Reverted", "Draft"];
    const selectedStatus = statuses[newValue];
    setFilteredContent(
      selectedStatus === "All"
        ? content
        : content.filter((item) => item.status === selectedStatus)
    );
  };

  const getTabCounts = (content: Content[]) => {
    const counts = {
      All: content.length,
      Pending: content.filter((item) => item.status === "Pending").length,
      Approved: content.filter((item) => item.status === "Approved").length,
      Reverted: content.filter((item) => item.status === "Reverted").length,
      Draft: content.filter((item) => item.status === "Draft").length,
    };
    return counts;
  };

  const tabLabels = ["All", "Pending Queue", "Approved", "Reverted", "Draft"];
  const tabCounts = getTabCounts(content);

  return (
    <div className={Styles.mainContent}>
      {isLoading ? (
        <p>Fetching data...</p>
      ) : (
        <Paper elevation={0} className={Styles.createNewBox} sx={{ p: 3, height: "100%" }}>
          <Paper sx={{ p: 2 }}>
            <StatusTabs
              tabValue={tabValue}
              handleTabChange={handleTabChange}
              tabLabels={tabLabels}
              tabCounts={tabCounts}
            />

            <TableContainer component={Paper} sx={{ mt: 2, boxShadow: "none" }}>
              <div className={Styles.FinalLists}>
                {filteredContent.length > 0 ? (
                  filteredContent.map((row) => (
                    <SipocCard
                      key={row.id}
                      row={row}
                      // handleDelete={handleDelete}
                      handleEdit={handleEdit} // Pass the edit handler
                      handleOpenModal={handleOpenModal}
                      handleClickOpen={handleClickOpen}
                      statusColors={statusColors}


                    />
                  ))
                ) : (
                  <Typography variant="body1" sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}>
                    No data available for this tab.
                  </Typography>
                )}
              </div>
            </TableContainer>
            <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
              Last Update: {lastUpdate.toLocaleString()}
            </Typography>
          </Paper>
        </Paper>
      )}


      {/* <SipocModal
        open={isModalOpen}
        onClose={handleCloseModal}
        sipocId={selectedSipocId}
        functionL1={functionL1}
        functionL2={functionL2}
        
      /> */}
      {/* <SipocModalAdmin open={isModalOpen} onClose={handleCloseModal} sipocId={selectedSipocId} functionL1={functionL1} functionL2={functionL2} /> */}
      {localStorage.getItem("role") === "manager" && (
        <SipocModal
          open={isModalOpen}
          onClose={handleCloseModal}
          sipocId={selectedSipocId}
          functionL1={functionL1}
          functionL2={functionL2}

        />
      )}

      {(localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "super_admin") && (
        <SipocModalAdmin
          open={isModalOpen}
          onClose={handleCloseModal}
          sipocId={selectedSipocId}
          functionL1={functionL1}
          functionL2={functionL2}
        />
      )}


      <DeleteConfirmationDialog open={open} handleClose={handleClose} handleDelete={handleDelete} row={content.find(item => item.id === deletingId)}
        loading={isLoading} />
    </div>
  );
};

export default FinalStatus;
